var exports = {
  "R": "participantAvatar__Jk444-",
  "B": "participantLimitNotice__08LyRt",
};

module.exports = exports;
